export default __webpack_public_path__ + "static/media/profile.a4738a33.jpg";